module.exports = __webpack_public_path__ + "files/88fd6f745b35e4de9f03518524b6ab6b.png";